import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { fleetEnvironment } from './fleet-environment';

export function postMapSetsVehicleGroupsCombinedAssignment(
  id: number,
  assignmentVehicleGroupIds: number[],
  unassignmentVehicleGroupIds: number[]
) {
  return fromFetch(
    new Request(fleetEnvironment.mapSetsVehicleGroupsAssignmentUrl(id), {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
      body: JSON.stringify({
        assignmentVehicleGroupIds,
        unassignmentVehicleGroupIds,
      }),
    })
  ).pipe(ignoreData());
}
